export default __webpack_public_path__ + "static/media/HideIcon.a72b31d4.svg";